import { publicRequest } from './api/auth';

// 部署層級旗標，與 tenant 無關，整個 session 查一次就夠。
// _cached 只在查得到時寫入；查不到維持 null，下次仍會重試。
let _cached = null;
let _inFlight = null;

class AirgappedService {
    /**
     * 本部署是否為 airgapped（地端隔離，無對外網路與 SMTP）。
     *
     * 回傳 true / false；查不到（逾時、非 2xx、回傳非物件）時回 null 代表「未知」。
     * 呼叫端應把未知視同非 airgapped、退回既有流程 —— 絕不能因為探測失敗
     * 就讓忘記密碼按不動。地端的那條路徑由後端保底接住。
     *
     * 注意：不帶 ?tenant=，旗標與租戶無關，後端在缺 tenant 時也會回這個欄位。
     */
    resolveAirgapped() {
        if (_cached !== null) return Promise.resolve(_cached);
        if (_inFlight) return _inFlight;

        _inFlight = publicRequest.get('/api/login/page-setting/')
            .then((res) => {
                if (!res || !res.data || typeof res.data !== 'object') return null;
                // 後端尚未上線時沒有這個欄位，視為非 airgapped（雲端行為）
                const value = res.data.airgapped === true;
                _cached = value;
                return value;
            })
            .catch(() => null)
            .finally(() => { _inFlight = null; });

        return _inFlight;
    }
}

export default new AirgappedService();
